module.exports = __webpack_public_path__ + "static/media/onogate-product-cover.4e9ceca5.png";